import { Button } from '@ps-design-system/components/Button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogTitle
} from '@ps-design-system/components/Dialog';
import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const BookingRequestErrorDialog = ({
  isOpen,
  setIsOpen,
  errorMsg,
  showSupportLink = true
}) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={setIsOpen}
      data-testingid="add-ons-dialog"
    >
      <DialogContent>
        <DialogBody style={{ paddingTop: '24px', textAlign: 'center' }}>
          <DialogTitle>
            <Text typeface="headline-3-m" style={{ marginBottom: '16px' }}>
              {errorMsg}
            </Text>
          </DialogTitle>

          {showSupportLink && (
            <Text>
              <FormattedMessage
                id="bookings_request_error_dialog.more_info"
                defaultMessage="More information about the likely cause for this error can be found in our {supportLink}."
                values={{
                  supportLink: (
                    <a
                      href="https://support.peerspace.com/hc/articles/360031059811-Why-did-my-credit-card-get-declined-"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline"
                    >
                      <FormattedMessage
                        id="bkc.bookings_request_modal.support_link"
                        defaultMessage="support center"
                      />
                    </a>
                  )
                }}
              />
            </Text>
          )}
        </DialogBody>

        <DialogFooter style={{ justifyContent: 'center' }}>
          <Button appearance="purple" onClick={() => setIsOpen(false)}>
            <FormattedMessage
              id="booking_request_error_dialog.okay"
              defaultMessage="Okay"
            />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

BookingRequestErrorDialog.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  errorMsg: PropTypes.string,
  showSupportLink: PropTypes.bool
};
